import { useState } from "react";

export function isJournalBrandImage(src) {
  if (!src || !src.trim()) return true;
  const path = src.split(/[?#]/)[0];
  return /\/(?:og-default\.(?:png|webp)|logo-(?:mark|full)\.(?:webp|png|svg))$/i.test(path);
}

export default function JournalImage({ src, alt, className = "", compact = false, ...props }) {
  const [failedSrc, setFailedSrc] = useState(null);
  const branded = isJournalBrandImage(src) || failedSrc === src;
  return (
    <img
      {...props}
      src={branded ? "/logo-full.webp" : src}
      alt={branded ? "Incolour Films" : alt}
      className={className}
      style={branded ? {
        backgroundColor: "#1c1b19",
        objectFit: "contain",
        padding: compact ? "0.5rem" : "clamp(2rem, 10%, 6rem)",
      } : undefined}
      onError={branded ? undefined : () => setFailedSrc(src)}
      data-journal-brand={branded ? "true" : undefined}
    />
  );
}
